/* Halford Gear — product page: variant picker + gallery.
   Sizing here is a government schedule, not a full grid: 51 of a possible
   84 chest x length combinations exist. So the picker has to (a) open on a
   COMMON size rather than the first one, or the page looks sold out, and
   (b) let a click on any size adjust the other option instead of dead-ending. */
(function () {
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants) || !variants.length) return;

    var idInput   = root.querySelector('[data-variant-id]');
    var priceEl   = root.querySelector('[data-price]');
    var skuEl     = root.querySelector('[data-sku]');
    var addBtn    = root.querySelector('[data-add]');
    var noteEl    = root.querySelector('[data-note]');
    var optCount  = parseInt(root.getAttribute('data-option-count'), 10) || 1;
    var moneyFmt  = root.getAttribute('data-money-format') || '${{amount}}';
    var selected  = [];

    function money(cents) {
      var v = (cents / 100).toLocaleString('en-US', {
        minimumFractionDigits: 2, maximumFractionDigits: 2
      });
      return moneyFmt.split('{{amount}}').join(v).split('{{ amount }}').join(v);
    }

    var live = variants.filter(function (v) { return v.available; });
    var pool = live.length ? live : variants;

    // How many other sizes share each option value. A value that appears in
    // many variants is a common one; scoring by it lands the opening
    // selection on something like 40 / Regular instead of 34 / X-Short.
    var freq = [];
    for (var i = 0; i < optCount; i++) {
      freq[i] = {};
      pool.forEach(function (v) {
        var k = v.options[i];
        freq[i][k] = (freq[i][k] || 0) + 1;
      });
    }
    function score(v) {
      return v.options.reduce(function (s, val, i) { return s + (freq[i][val] || 0); }, 0);
    }

    function match(sel) {
      return variants.find(function (v) {
        return sel.every(function (val, i) { return val !== null && v.options[i] === val; });
      }) || null;
    }

    // Best in-stock variant satisfying the non-null constraints.
    function bestWith(constraints) {
      var cands = pool.filter(function (v) {
        return constraints.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      });
      if (!cands.length) return null;
      return cands.reduce(function (a, b) { return score(b) > score(a) ? b : a; });
    }

    // Seed: honour ?variant= if it names a real one, else open on a common size.
    var seeded = null;
    try {
      var want = new URL(window.location.href).searchParams.get('variant');
      if (want) seeded = variants.find(function (v) { return String(v.id) === String(want); });
    } catch (e) { /* no URL support */ }
    if (!seeded) seeded = bestWith(new Array(optCount).fill(null));
    if (!seeded) seeded = variants[0];
    selected = seeded.options.slice(0, optCount);

    function paintSelection() {
      root.querySelectorAll('.vswatch').forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-opt'), 10);
        btn.setAttribute('aria-pressed',
          btn.getAttribute('data-value') === selected[i] ? 'true' : 'false');
      });
    }

    // Hatch the values that do not pair with the current picks. They stay
    // clickable — clicking one moves the other option instead of failing.
    function refreshAvailability() {
      root.querySelectorAll('.vswatch').forEach(function (btn) {
        var i = parseInt(btn.getAttribute('data-opt'), 10);
        var probe = selected.slice();
        probe[i] = btn.getAttribute('data-value');
        var exists = pool.some(function (v) {
          return probe.every(function (val, j) {
            return j === i ? v.options[j] === val
                           : (val === null || v.options[j] === val);
          });
        });
        btn.setAttribute('data-unavailable', exists ? 'false' : 'true');
      });
    }

    function render() {
      var v = match(selected);

      root.querySelectorAll('.vopt').forEach(function (g, i) {
        var out = g.querySelector('[data-picked]');
        if (out) out.textContent = selected[i] || '';
      });

      paintSelection();
      refreshAvailability();

      if (!v) {
        if (idInput) idInput.value = '';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
        if (noteEl) noteEl.textContent = 'That chest and length are not made together.';
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceEl) {
        priceEl.innerHTML = money(v.price) +
          (v.compare_at_price && v.compare_at_price > v.price
            ? ' <span class="was">' + money(v.compare_at_price) + '</span>' : '');
      }
      if (skuEl) skuEl.innerHTML = v.sku ? 'NSN / SKU <b>' + v.sku + '</b>' : '';
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      }
      if (noteEl) noteEl.textContent = v.available ? '' : 'Out of stock in this size.';

      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.vswatch');
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      var i = parseInt(btn.getAttribute('data-opt'), 10);
      var val = btn.getAttribute('data-value');

      var probe = selected.slice();
      probe[i] = val;

      if (match(probe)) {
        selected = probe;
      } else {
        // Keep what they just clicked; move the other options to the closest
        // size that actually exists, rather than showing an error.
        var constraints = [];
        for (var k = 0; k < optCount; k++) constraints[k] = (k === i ? val : null);
        var best = bestWith(constraints);
        selected = best ? best.options.slice(0, optCount) : probe;
      }
      render();
    });

    render();
  });

  // gallery thumbnails
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var main = gal.querySelector('[data-gallery-main]');
    if (!main) return;
    gal.addEventListener('click', function (e) {
      var t = e.target.closest('.pgal-thumb');
      if (!t) return;
      e.preventDefault();
      var full = t.getAttribute('data-full');
      var alt  = t.getAttribute('data-alt') || '';
      if (full) { main.src = full; main.alt = alt; }
      gal.querySelectorAll('.pgal-thumb').forEach(function (x) {
        x.setAttribute('aria-current', x === t ? 'true' : 'false');
      });
    });
  });
})();
